import $ from 'gridstrap/lib/gs-zepto';

export class GSReadMore {
	private root;
	private button;

	constructor(root) {
		this.root = $(root);
		this.button = this.root.find('.gs-ReadMore-button');
		this.button.on('click', () => this.open());
	}

	open() {
		this.root.addClass('gs-ReadMore--isExpanded');
	}

	gsOnDestroy() {
		this.button.off('click');
	}
}
